import { Injectable } from "@angular/core";
import { HttpInterceptor } from "../interceptors/http-interceptor.service";
import { Globals } from "../globals";
import { PermisoService } from "./permiso.service";
import { Observable } from "rxjs/Observable";
import { Response } from '@angular/http';
import { GeneralService } from "./general.service";

@Injectable()
export class ContactoService {
    constructor(
        private http: HttpInterceptor,
        private globals: Globals,
        private general: GeneralService,
        private permisoService: PermisoService) {
    }

    asignarContacto(id_entidad: any, id_contacto: any): Observable<any> {
        return this.http
            .post(
                this.general.webserver + 'apiContacto/asignarContacto',
                JSON.stringify({
                    idCliente: localStorage.getItem('idCliente'),
                    id_entidad: id_entidad,
                    id_contacto: id_contacto
                })
            ).map(
                (respuesta: Response) => respuesta.json());
    }

    crearContacto(model: any): Observable<any> {

        return this.http
            .post(
                this.general.webserver + 'apiContacto/crearContacto',
                JSON.stringify({
                    idCliente: localStorage.getItem('idCliente'),
                    contacto: model,
                })
            ).map(
                (respuesta: Response) => respuesta.json());
    }
    //Servicio para buscador general.
    buscarDatos(model: any): Observable<any> {

        return this.http
            .post(
                this.general.webserver + 'apiPropuesta/searchBar',
                JSON.stringify({
                    idCliente: localStorage.getItem('idCliente'),
                    searchbar: model,
                })
            ).map(
                (respuesta: Response) => respuesta.json());
    }

    editarContacto(model: any): Observable<any> {
        return this.http
            .post(
                this.general.webserver + 'apiContacto/editarContacto',
                JSON.stringify({
                    idCliente: localStorage.getItem('idCliente'),
                    contacto: model
                })
            ).map(
                (respuesta: Response) => respuesta.json());
    }

    eliminarContacto(model: any): Observable<any> {
        return this.http
            .post(
                this.general.webserver + 'apiContacto/eliminarContacto',
                JSON.stringify({
                    idCliente: localStorage.getItem('idCliente'),
                    contacto: model
                })
            ).map(
                (respuesta: Response) => respuesta.json());
    }

    getTiposContacto(
        paginado: any = { // siempre traigo todos
            page: null,
            pageSize: null
        },
        orden: any = {
            sort: 'Descripcion',
            order: 'asc'
        },
        filtros: any = {
            generico: ''
        }
    ): Observable<any> {
        return this.permisoService.getPermisoAction('TIPOS-CONTACTO-VER')
            .switchMap((controllerAction) => { // operando que espera a que termine el primer observable para iniciar el segundo
                return this.http
                    .post(
                        this.general.webserver + controllerAction,
                        JSON.stringify({
                            idCliente: localStorage.getItem('idCliente'),
                            paginado: paginado,
                            orden: orden,
                            filtros: filtros
                        })
                    );
            })
            .map( // espera que terminen todos los operandos que haya para actuar sobre el dato final que llega del server
                (respuesta: Response) => respuesta.json());
    }

    getContactos(
        paginado: any = {
            page: null,
            pageSize: 50
        },
        orden: any = {
            sort: 'nombre',
            order: 'asc'
        },
        filtros: any = {
            IdContacto:'',
            generico: ''
        }
    ): Observable<any> {
        return this.permisoService
            .getPermisoAction('CONTACTO-VER')
            .switchMap((controllerAction) => { // operando que espera a que termine el primer observable para iniciar el segundo
                return this.http
                    .post(
                        this.general.webserver + controllerAction,
                        JSON.stringify({
                            idCliente: localStorage.getItem('idCliente'),
                            paginado: paginado,
                            orden: orden,
                            filtros: filtros
                        })
                    );
            })
            .map( // espera que terminen todos los operandos que haya para actuar sobre el dato final que llega del server
                (respuesta: Response) => respuesta.json());
    }
}
